import { Node } from 'prosemirror-model'
import { pick } from 'lodash'
import { schema } from 'prose-core'

export const getListFormatAttrs = (node?: Node | null) => {
  if (!node) return {}

  if (node.type === schema.nodes.unordered_list) {
    return pick(node.attrs, ['markerFormat'])
  } else if (node.type === schema.nodes.ordered_list) {
    return pick(node.attrs, ['counterSeparator', 'counterStyles', 'flattenMarker'])
  }

  return {}
}
